import { createContext, useContext } from 'react';

interface AssistantContextInterface {
  isAssistantEnabled: boolean;
}

const initialContext: AssistantContextInterface = {
  isAssistantEnabled: false,
};

export const AssistantContext = createContext<AssistantContextInterface>(initialContext);
export const useAssistant = () => useContext(AssistantContext);
